import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import logo from "../assets/mslogo1.png";
import { LogOut, User } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  const isLoggedIn = localStorage.getItem("token");
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    navigate("/login");
    window.location.reload();
  };

  const userId = localStorage.getItem("userId");
  
  const navItems = [
    { name: "Home", dropdownItems: [], link: "/" },

    {
      name: "About",
      dropdownItems: [],
      link: "/about",
    },
    {
      name: "Study Abroad",
      dropdownItems: [
        { name: "Canada", link: "/country-overview/canada" },
        { name: "USA", link: "/country-overview/usa" },
        { name: "Germany", link: "/country-overview/germany" },
        { name: "Europe", link: "/country-overview/europe" },
        { name: "Australia", link: "/country-overview/australia" },
        { name: "New Zealand", link: "/country-overview/newzealand" },
      ],
      link: "/study-abroad",
    },
    {
      name: "Services",
      dropdownItems: [
        { name: "Study Abroad", link: "/study-abroad" },
        { name: "English Proficiency", link: "/test-prep" },
        { name: "Visa Process", link: "/visa" },
        { name: "Counselling", link: "/counselling" },
      ],
      link: "",
    },
    {
      name: "Test Prep",
      dropdownItems: [
        { name: "IELTS", link: "/ielts" },
        { name: "PTE", link: "/pte" },
        { name: "TOEFL", link: "/toefl" },
        { name: "DULINGO", link: "/duolingo" },
        { name: "GRE", link: "/gre" },
        { name: "SAT", link: "/sat" },
      ],
      link: "/test-prep",
    },
    { name: "Universities", link: "/universities" },
    {
      name: "Events",
      dropdownItems: [],
      link: "/events",
    },
    { name: "Contact Us", dropdownItems: [], link: "/contact" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-[#fff] bg-opacity-60 shadow-md border-b border-gray-200 backdrop-blur-lg">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src={logo}
                alt="M.S EDU"
                className="h-14 sm:h-20 md:h-16 transition-transform duration-300 hover:scale-110"
              />
            </Link>
          </div>

          {/* Mobile menu button and profile */}
          <div className="xl:hidden flex items-center gap-3">
            {/* Mobile Profile Button */}
            {userId ? (
              <div className="relative">
                <button
                  onClick={() => setOpen(!open)}
                  className="bg-[#A67C52] text-[#F8F1E9] p-2 rounded-full flex items-center justify-center hover:bg-[#4B2E2F] transition-all duration-300"
                >
                  <User className="w-5 h-5" />
                </button>

                {/* Mobile Dropdown */}
                {open && (
                  <div className="absolute right-0 mt-2 w-40 bg-white rounded-xl shadow-lg border z-50 overflow-hidden">
                    <Link
                      to={`/profile/${userId}`}
                      className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100"
                      onClick={() => {
                        setOpen(false);
                        setIsNavOpen(false);
                      }}
                    >
                      <User size={16} /> Profile
                    </Link>

                    <button
                      onClick={() => {
                        handleLogout();
                        setOpen(false);
                      }}
                      className="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    >
                      <LogOut size={16} /> Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link
                to="/login"
                className="bg-[#A67C52] text-[#F8F1E9] px-3 py-2 rounded-lg text-sm font-medium hover:bg-[#4B2E2F] transition-all duration-300"
              >
                Login
              </Link>
            )}

            {/* Hamburger Menu */}
            <button
              onClick={() => setIsNavOpen(!isNavOpen)}
              className="text-[#003366] hover:text-[#6A85B6] transition-colors p-1"
            >
              <svg
                className="h-8 w-8"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isNavOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex xl:items-center xl:flex-wrap gap-x-4 gap-y-2">
            {navItems.map((item, index) => (
              <div key={index} className="relative group min-w-max">
                {item?.name === "Contact Us" ? (
                  <HashLink
                    onMouseEnter={() => setIsDropdownOpen(index)}
                    smooth
                    to={item.link}
                    className="text-[#003366] hover:text-[#6A85B6] font-medium px-3 py-2 rounded-lg hover:bg-[#6A85B6] hover:bg-opacity-10 transition-all duration-300 hover:-translate-y-1"
                  >
                    {item?.name}
                  </HashLink>
                ) : (
                  <Link
                    onMouseEnter={() => setIsDropdownOpen(index)}
                    onClick={(e) => setIsDropdownOpen(index)}
                    to={item.link}
                    className="text-[#003366] hover:text-[#6A85B6] font-medium px-3 py-2 rounded-lg hover:bg-[#6A85B6] hover:bg-opacity-10 transition-all duration-300 hover:-translate-y-1"
                  >
                    {item?.name}
                  </Link>
                )}
                {item.dropdownItems?.length > 0 && isDropdownOpen === index && (
                  <div className="absolute left-0 mt-2 w-60 rounded-lg bg-white shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform -translate-y-2 group-hover:translate-y-0">
                    <div className="py-2">
                      {item.dropdownItems.map((dropdownItem) => (
                        <Link
                          onClick={(e) => setIsDropdownOpen(null)}
                          key={dropdownItem.name}
                          to={dropdownItem.link}
                          className="block px-4 py-3 text-sm text-[#4B2E2F] hover:bg-[#A67C52] hover:text-white transition-colors duration-300"
                        >
                          {dropdownItem.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* Desktop Right side buttons */}
          <div className="hidden xl:flex items-center space-x-6">
            {userId ? (
              <div className="relative">
                {/* Desktop Profile Button */}
                <button
                  onClick={() => setOpen(!open)}
                  className="bg-[#A67C52] text-[#F8F1E9] px-3 py-2 rounded-full flex items-center gap-2 font-medium hover:bg-[#4B2E2F] transition-all duration-300"
                >
                  <User />
                </button>

                {/* Desktop Dropdown */}
                {open && (
                  <div className="absolute right-0 mt-2 w-40 bg-white rounded-xl shadow-lg border z-50 overflow-hidden">
                    <Link
                      to={`/profile/${userId}`}
                      className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100"
                      onClick={() => setOpen(false)}
                    >
                      <User size={16} /> Profile
                    </Link>

                    <button
                      onClick={handleLogout}
                      className="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    >
                      <LogOut size={16} /> Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              // <Link
              //   to="https://forms.gle/2aJy2MgttfAzYhWaA"
              //   target="_blank"
              //   className="bg-[#A67C52] text-[#F8F1E9] px-3 py-2 rounded-lg font-medium hover:bg-[#4B2E2F] transition-all duration-300 hover:scale-105"
              // >
              //   We are Hiring
              // </Link>
              <Link
                to="/login"
                className="bg-[#A67C52] text-[#F8F1E9] px-3 py-2 rounded-lg font-medium hover:bg-[#4B2E2F] transition-all duration-300 hover:scale-105"
              >
                Login
              </Link>
            )}
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div
          className={`xl:hidden transition-all duration-300 ease-in-out ${
            isNavOpen
              ? "max-h-[1000px] opacity-100 visible"
              : "max-h-0 opacity-0 invisible"
          }`}
        >
          <nav className="pt-2 pb-4 space-y-2">
            {navItems.map((item, index) => (
              <div key={index}>
                <div
                  className="flex justify-between items-center px-4 py-2 text-[#003366] hover:bg-[#6A85B6] hover:bg-opacity-10 rounded-lg transition-colors cursor-pointer"
                  onClick={() => {
                    if (item.dropdownItems?.length > 0) {
                      setOpenDropdown(openDropdown === index ? null : index);
                    } else {
                      setIsNavOpen(false);
                      setOpenDropdown(null);
                    }
                  }}
                >
                  {item.name === "Contact Us" ? (
                    <HashLink
                      smooth
                      to={item.link}
                      className="flex-grow"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsNavOpen(false);
                      }}
                    >
                      {item.name}
                    </HashLink>
                  ) : (
                    <Link
                      to={item.link}
                      className="flex-grow"
                      onClick={(e) => {
                        if (item.dropdownItems?.length === 0) {
                          setIsNavOpen(false);
                        } else {
                          e.preventDefault();
                        }
                      }}
                    >
                      {item.name}
                    </Link>
                  )}
                  {item.dropdownItems?.length > 0 && (
                    <svg
                      className={`h-5 w-5 transition-transform ${
                        openDropdown === index ? "rotate-180" : "rotate-0"
                      }`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  )}
                </div>
                {openDropdown === index && (
                  <div className="pl-6 mt-1 space-y-1">
                    {item.dropdownItems.map((dropdownItem) => (
                      <Link
                        onClick={() => {
                          setIsNavOpen(false);
                          setOpenDropdown(null);
                        }}
                        key={dropdownItem.name}
                        to={dropdownItem.link}
                        className="block px-4 py-2 text-sm text-[#4B2E2F] hover:bg-[#A67C52] hover:text-white rounded-lg transition-colors"
                      >
                        {dropdownItem.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>
          
          {/* Mobile Bottom Actions */}
          {!userId && (
            <div className="px-4 py-4 space-y-4 border-t border-gray-200">
              <Link
                to="https://forms.gle/2aJy2MgttfAzYhWaA"
                target="_blank"
                className="block w-full text-center bg-[#A67C52] text-[#F8F1E9] px-6 py-3 rounded-lg font-medium hover:bg-[#4B2E2F] transition-colors"
                onClick={() => setIsNavOpen(false)}
              >
                We are Hiring
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}